import React, { useMemo } from "react";
import { OutlinedEditDeleteTrash } from '@hose/eui-icons'
import moment from 'moment'
import {thousandBitSeparator} from '../../utils/tools'
import './RelatedItem.less'
import { IRequisitionMatched } from "../../types/dataMatched";

export interface RelatedItemProps extends IRequisitionMatched {
  mark?: string
  className?: string
  onDelete?: (code: string) => void
}

export const RelatedItem: React.FC<RelatedItemProps> = (props) => {
  const { name, requisitionDate, code, requisitionMoneyNode, className, onDelete, mark = '申请金额' } = props

  const amount = useMemo(() => {
    if(requisitionMoneyNode){
      const standardValue = Number(requisitionMoneyNode.standard).toFixed(Number(requisitionMoneyNode?.standardScale))
      return `${requisitionMoneyNode?.standardStrCode} ${thousandBitSeparator(standardValue)}`
    }
    return '无金额'
  }, [requisitionMoneyNode])

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation()
    code && onDelete?.(code)
  }
  return <section className={`related-item-wrapper ${className}`}>
    <div className="left">
      <div className="title">{name}</div>
      <div className="desc">
        <span>{code}</span>
        {requisitionDate && <span>{moment(requisitionDate).format('YYYY/MM/DD')}</span>}
      </div>
    </div>
    <div className="right">
      <div className="right-content">
        <div className="amount">{amount}</div>
        <div className="mark">{mark}</div>
      </div>
      {typeof onDelete === 'function' && <div className="delete" onClick={handleDelete}>
        <OutlinedEditDeleteTrash fontSize={14} color="var(--eui-icon-n1, rgba(29, 33, 41, 0.80))" />
      </div>}
    </div>
  </section>
}

export default RelatedItem